/**
 * If you're adding an icon
 * please sort alphabetically
 */
import AccountIcon from "@mui/icons-material/AccountCircleOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddIcon from "@mui/icons-material/AddOutlined";
import AlarmIcon from "@mui/icons-material/Alarm";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AssignedIcon from "@mui/icons-material/HowToRegOutlined";
import AssignmentTurnedInOutlined from "@mui/icons-material/AssignmentTurnedInOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import BarChartIcon from "@mui/icons-material/Equalizer";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import ChatIcon from "@mui/icons-material/ChatOutlined";
import CheckBoxCheckedIcon from "@mui/icons-material/CheckBox";
import CheckBoxIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckIcon from "@mui/icons-material/Check";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CircleBlank from "@mui/icons-material/CircleOutlined";
import CircleChecked from "@mui/icons-material/CheckCircleOutline";
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import CloseOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import EditIcon from "@mui/icons-material/EditOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import EndDateIcon from "@mui/icons-material/EventBusyOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FilterListIcon from "@mui/icons-material/FilterList";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import GlobeIcon from "@mui/icons-material/LanguageOutlined";
import GridIcon from "@mui/icons-material/GridOn";
import GroupIcon from "@mui/icons-material/GroupsOutlined";
import HelpIcon from "@mui/icons-material/HelpOutline";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import LinkIcon from "@mui/icons-material/Link";
import ListOutlined from "@mui/icons-material/ListOutlined";
import Lock from "@mui/icons-material/Lock";
import LockOpen from "@mui/icons-material/LockOpen";
import LockOpenOutlined from "@mui/icons-material/LockOpenOutlined";
import LockOutlined from "@mui/icons-material/LockOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import NoChangeIcon from "@mui/icons-material/Remove";
import NoteIcon from "@mui/icons-material/StickyNote2Outlined";
import NotificationIcon from "@mui/icons-material/NotificationsOutlined";
import OpenBookIcon from "@mui/icons-material/AutoStoriesOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAddAltOutlined";
import PhoneIcon from "@mui/icons-material/PhoneIphoneOutlined";
import QrCodeIcon from "@mui/icons-material/QrCode";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ReplyIcon from "@mui/icons-material/ReplyOutlined";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSendOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/SendOutlined";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutralOutlined";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfiedOutlined";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfiedOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfiedOutlined";
import ShareIcon from "@mui/icons-material/IosShare";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SmilingFaceFilledIcon from "@mui/icons-material/EmojiEmotions";
import SubdirectoryArrowRight from "@mui/icons-material/SubdirectoryArrowRight";
import ViewAgendaOutlinedIcon from "@mui/icons-material/ViewAgendaOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const SmilingFaceOutlinedIcon = SentimentVerySatisfiedIcon;

export {
    AccountIcon,
    AddCircleOutlineIcon,
    AddIcon,
    AlarmIcon,
    ArrowDownwardIcon,
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    ArrowUpwardIcon,
    AssignedIcon,
    AssignmentTurnedInOutlined,
    AssistantOutlinedIcon,
    BarChartIcon,
    CampaignOutlinedIcon,
    CancelIcon,
    ChatIcon,
    CheckBoxCheckedIcon,
    CheckBoxIcon,
    CheckIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    CircleBlank,
    CircleChecked,
    CircleIcon,
    CloseIcon,
    CloseOutlinedIcon,
    DataUsageIcon,
    DownloadIcon,
    DraftsOutlinedIcon,
    EditIcon,
    EmailIcon,
    EndDateIcon,
    ExpandMoreIcon,
    ExpandLessIcon,
    FavoriteBorderIcon,
    FilterListIcon,
    FormatItalicIcon,
    FormatBoldIcon,
    GlobeIcon,
    GridIcon,
    GroupIcon,
    HelpIcon,
    InfoIcon,
    LinkIcon,
    ListOutlined,
    Lock,
    LockOpen,
    LockOpenOutlined,
    LockOutlined,
    MarkEmailReadOutlinedIcon,
    NoChangeIcon,
    NoteIcon,
    NotificationIcon,
    OpenBookIcon,
    PersonAddIcon,
    PhoneIcon,
    QrCodeIcon,
    RefreshIcon,
    RemoveCircleOutlineIcon,
    ReplayIcon,
    ReplyIcon,
    ScheduleSendIcon,
    SearchIcon,
    SendIcon,
    SentimentDissatisfiedIcon,
    SentimentNeutralIcon,
    SentimentSatisfiedIcon,
    SentimentVeryDissatisfiedIcon,
    SentimentVerySatisfiedIcon,
    ShareIcon,
    ShortTextIcon,
    SmilingFaceFilledIcon,
    SmilingFaceOutlinedIcon,
    SubdirectoryArrowRight,
    ViewAgendaOutlinedIcon,
    VisibilityOffOutlinedIcon,
    VisibilityOutlinedIcon,
};
